<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<!-- Header -->
<div class="cssLayoutRowStartCenter">
  <div class="sp-icon" style="margin-right: 10px;">
    <mat-icon class="mdi-24px" fontIcon="mdi-clipboard-account-outline" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <button mat-icon-button (click)="addOrEditDuty(null)" style="outline: none; margin-left: 20px;" title="Add Duty"
    [disabled]="!selectedEvaluationId || !canEdit">
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
  </button>
  <mat-form-field class="button-margins team-selector">
    <mat-label>Team</mat-label>
    <mat-select placeholder="Team" [value]="selectedTeamId" (selectionChange)="selectTeam($event.value)">
      <mat-option value="">All Teams</mat-option>
      @for (team of teamList; track team.id) {
      <mat-option [value]="team.id">
        {{ team.name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="button-margins search-field">
    <input matInput [formControl]="filterControl" placeholder="Search" />
    @if (filterControl.value) {
    <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
</div>

<!-- Table -->
<div class="table-container elevate">
  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><span style="margin-left: 80px;">Name</span></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="addOrEditDuty(row); $event.stopPropagation()" title="Edit Duty">
          <mat-icon class="mdi-18px" fontIcon="mdi-square-edit-outline">
          </mat-icon>
        </button>
        <button mat-icon-button class="button-end" (click)="deleteDutyRequest(row); $event.stopPropagation()"
          title="Delete Duty" [disabled]="!canEdit">
          <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
        {{ row.name }}
      </td>
    </ng-container>

    <!-- Team Column -->
    <ng-container matColumnDef="teamId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Team</th>
      <td mat-cell *matCellDef="let row">
        {{ getTeamName(row.teamId) }}
      </td>
    </ng-container>

    <!-- Users Column -->
    <ng-container matColumnDef="users">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Users</th>
      <td mat-cell *matCellDef="let row">
        @for (user of row.users; track user) {
        <span>
          {{ user.name }}
        </span>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No matching data</td>
    </tr>
  </table>
</div>

<!-- Loading Indicator -->
@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
